<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="bidDescription">Job</label>
                    <input id="bidDescription" type="text" class="form-control" [(ngModel)]="target.bidDescription" name="bidDescription" />
                </div>
            </div>
        </div>
        <hr />

        <h6>Optional Details for Analytics</h6>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="additionalDescription">Additional Description</label>
                    <textarea
                        id="additionalDescription"
                        rows="3"
                        class="form-control"
                        [(ngModel)]="target.additionalDescription"
                        name="additionalDescription"
                    ></textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="noticeToProceed">Notice To Proceed Date</label>
                    <wj-input-date [(ngModel)]="target.noticeToProceed" name="noticeToProceed" [isRequired]="false"></wj-input-date>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="competitorIds">Pre-Bid Attendees</label>
                    <wj-multi-select
                        name="competitorIds"
                        [showSelectAllCheckbox]="false"
                        [showFilterInput]="true"
                        [checkOnFilter]="false"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [checkedMemberPath]="'selected'"
                        [placeholder]="'Select Attendees'"
                        [headerFormat]="'{count:n0} items'"
                        [itemsSource]="competitorsList"
                    >
                    </wj-multi-select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="isDeep">Deeper Than 12'</label>
                    <wj-combo-box
                        id="isDeep"
                        [(ngModel)]="target.isDeep"
                        name="isDeep"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="hasTrafficControl">Significant Traffic Control</label>
                    <wj-combo-box
                        id="hasTrafficControl"
                        [(ngModel)]="target.hasTrafficControl"
                        name="hasTrafficControl"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="hasDewatering">Significant Dewatering</label>
                    <wj-combo-box
                        id="hasDewatering"
                        [(ngModel)]="target.hasDewatering"
                        name="hasDewatering"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="hasBypassPumping">Bypass Pumping</label>
                    <wj-combo-box
                        id="hasBypassPumping"
                        [(ngModel)]="target.hasBypassPumping"
                        name="hasBypassPumping"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="hasTightTimeFrame">Tight Time Frame</label>
                    <wj-combo-box
                        id="hasTightTimeFrame"
                        [(ngModel)]="target.hasTightTimeFrame"
                        name="hasTightTimeFrame"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="isTightJobSite">Tight Job Site / Little Staging</label>
                    <wj-combo-box
                        id="isTightJobSite"
                        [(ngModel)]="target.isTightJobSite"
                        name="isTightJobSite"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="hasHaulOff">Significant Haul Off</label>
                    <wj-combo-box
                        id="hasHaulOff"
                        [(ngModel)]="target.hasHaulOff"
                        name="hasHaulOff"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="hasInsuranceRequirement">Health Insurance Requirement</label>
                    <wj-combo-box
                        id="hasInsuranceRequirement"
                        [(ngModel)]="target.hasInsuranceRequirement"
                        name="hasInsuranceRequirement"
                        [itemsSource]="boolList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
